import { blue, green, orange, red, grey } from '@material-ui/core/colors';

export const COMPLAINT_STATUSES = {
  PENDING_HOST: 'pending_host',
  PENDING_GUEST: 'pending_guest',
  ACCEPTED: 'accepted',
  ESCALATED: 'escalated',
  RESOLVED: 'resolved',
  WITHDRAWN: 'withdrawn',
};

export const STATUS_COLORS = {
  [COMPLAINT_STATUSES.PENDING_HOST]: { backgroundColor: orange[500], color: '#fff' },
  [COMPLAINT_STATUSES.PENDING_GUEST]: { backgroundColor: orange[500], color: '#fff' },
  [COMPLAINT_STATUSES.ACCEPTED]: { backgroundColor: green[500], color: '#fff' },
  [COMPLAINT_STATUSES.ESCALATED]: { backgroundColor: red[500], color: '#fff' },
  [COMPLAINT_STATUSES.RESOLVED]: { backgroundColor: blue[500], color: '#fff' },
  [COMPLAINT_STATUSES.WITHDRAWN]: null,
};

export const WAITING_COLOR = { backgroundColor: grey[700], color: '#fff' };

export const ACTION_COLORS = {
  accept: green[500],
  reject: red[500],
  counter_offer: orange[500],
  resolve: blue[500],
};

export const MAX_DESCRIPTION_LENGTH = 5000;
export const MAX_COMMENT_LENGTH = 5000;

export const formatCottageLabel = (cottage) => {
  if (!cottage?.id) return null;
  return cottage.title_sv ? `#${cottage.id} - ${cottage.title_sv}` : `#${cottage.id}`;
};
